import React from 'react';

const CookiePolicy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem', color: '#333', lineHeight: '1.6' }}>
      <h1>Cookie Policy</h1>
      <p><strong>Effective Date:</strong> July 22, 2026</p>
      <p><strong>Website:</strong> https://synthetica-3bf2d.web.app/</p>

      <hr style={{ margin: '1.5rem 0', borderColor: '#eee' }} />

      <section>
        <h2>1. What Are Cookies and Local Storage?</h2>
        <p>
          Cookies are small text files stored on your device when you load a website. In addition to cookies, modern web applications often use <strong>Local Storage</strong> and <strong>Session Storage</strong>, which allow data to be saved directly in your web browser.
        </p>
      </section>

      <section>
        <h2>2. How Synthetica Uses Browser Storage</h2>
        <p>
          Synthetica relies strictly on essential session storage and cookies to provide functional web features. We do not use third-party cross-site tracking or advertising cookies.
        </p>

        <h3>A. Essential Authentication Cookies</h3>
        <p>
          When you log in, <strong>Google Firebase Authentication</strong> uses browser storage to safely maintain your active session. This ensures you stay signed in as you navigate between pages without needing to re-enter your credentials continuously.
        </p>

        <h3>B. Application Preferences & State</h3>
        <p>
          We use local storage to save user preferences, active state, and temporary input data needed for text classification routines.
        </p>
      </section>

      <section>
        <h2>3. Third-Party Services</h2>
        <p>
          Our application infrastructure utilizes services hosted by <strong>Google Firebase</strong> and <strong>PythonAnywhere</strong>. These providers may place essential technical headers or cookies necessary to authenticate API requests, enforce security policies, and prevent malicious requests.
        </p>
      </section>

      <section>
        <h2>4. Managing and Disabling Cookies</h2>
        <p>
          You can control or clear cookies and local storage through your web browser settings:
        </p>
        <ul>
          <li><strong>Google Chrome:</strong> Settings &gt; Privacy and security &gt; Third-party cookies / Site data</li>
          <li><strong>Mozilla Firefox:</strong> Settings &gt; Privacy &amp; Security &gt; Cookies and Site Data</li>
          <li><strong>Safari:</strong> Preferences &gt; Privacy &gt; Manage Website Data</li>
        </ul>
        <p>
          <em>Note: Clearing or disabling essential authentication storage will sign you out and may prevent certain interactive features of Synthetica from functioning properly.</em>
        </p>
      </section>

      <section>
        <h2>5. Updates to This Policy</h2>
        <p>
          We may update this Cookie Policy periodically to reflect changes in technical requirements or operational standards.
        </p>
      </section>

      <section>
        <h2>6. Contact Us</h2>
        <p>
          If you have questions regarding our use of cookies or local storage, please contact us through the available options on the Synthetica platform.
        </p>
      </section>
    </div>
  );
};

export default CookiePolicy;